module.exports = __webpack_public_path__ + "static/media/lock-is-correct.82becfa7.mp3";